import React from "react";

/* 인라인 SVG 아이콘 — 외부 의존성 없음 */
const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const Icon = {
  Circuit: (p) => (
    <svg {...base} {...p}>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M9 4v3M15 4v3M9 20v-3M15 20v-3M4 9h3M4 15h3M20 9h-3M20 15h-3" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  ),
  Chip: (p) => (
    <svg {...base} {...p}>
      <rect x="6" y="6" width="12" height="12" rx="1" />
      <path d="M9 2v4M15 2v4M9 18v4M15 18v4M2 9h4M2 15h4M18 9h4M18 15h4" />
    </svg>
  ),
  Code: (p) => (
    <svg {...base} {...p}>
      <path d="m8 8-4 4 4 4" />
      <path d="m16 8 4 4-4 4" />
      <path d="m14 4-4 16" />
    </svg>
  ),
  Globe: (p) => (
    <svg {...base} {...p}>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3c2.4 2.5 3.7 5.7 3.7 9s-1.3 6.5-3.7 9c-2.4-2.5-3.7-5.7-3.7-9S9.6 5.5 12 3Z" />
    </svg>
  ),
  Box: (p) => (
    <svg {...base} {...p}>
      <path d="M21 8 12 3 3 8v8l9 5 9-5V8Z" />
      <path d="m3 8 9 5 9-5" />
      <path d="M12 13v8" />
    </svg>
  ),
  Wrench: (p) => (
    <svg {...base} {...p}>
      <path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.4 2.4-2.7-2.7 2.1-2.7Z" />
    </svg>
  ),
  Award: (p) => (
    <svg {...base} {...p}>
      <circle cx="12" cy="9" r="6" />
      <path d="m8.6 14.3-1.6 7.2 5-2.9 5 2.9-1.6-7.2" />
    </svg>
  ),
  Lightbulb: (p) => (
    <svg {...base} {...p}>
      <path d="M12 3a6 6 0 0 0-3.6 10.8c.5.4.8 1 .9 1.6l.1.6h5.2l.1-.6c.1-.6.4-1.2.9-1.6A6 6 0 0 0 12 3Z" />
      <path d="M9.5 19h5" />
      <path d="M10.5 21.5h3" />
    </svg>
  ),
  Mail: (p) => (
    <svg {...base} {...p}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </svg>
  ),
  Phone: (p) => (
    <svg {...base} {...p}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.8a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.35 1.84.59 2.8.72A2 2 0 0 1 22 16.92Z" />
    </svg>
  ),
  ArrowRight: (p) => (
    <svg {...base} strokeWidth="1.8" {...p}>
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </svg>
  ),
  Check: (p) => (
    <svg {...base} strokeWidth="2" {...p}>
      <path d="m4 12 5 5L20 6" />
    </svg>
  ),
  Doc: (p) => (
    <svg {...base} {...p}>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
      <path d="M14 3v5h5" />
      <path d="M9 13h6M9 17h6" />
    </svg>
  ),
  Shield: (p) => (
    <svg {...base} {...p}>
      <path d="M12 3 4 6v6c0 4.4 3.2 8.2 8 9 4.8-.8 8-4.6 8-9V6Z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  ),
  Layers: (p) => (
    <svg {...base} {...p}>
      <path d="m12 3 9 5-9 5-9-5Z" />
      <path d="m3 13 9 5 9-5" />
    </svg>
  ),
  Motion: (p) => (
    <svg {...base} {...p}>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v4M12 18v4M2 12h4M18 12h4" />
      <path d="m5 5 2.5 2.5M16.5 16.5 19 19M19 5l-2.5 2.5M7.5 16.5 5 19" />
    </svg>
  ),
  Server: (p) => (
    <svg {...base} {...p}>
      <rect x="3" y="4" width="18" height="7" rx="2" />
      <rect x="3" y="13" width="18" height="7" rx="2" />
      <path d="M7 7.5h.01M7 16.5h.01" />
    </svg>
  ),
  Download: (p) => (
    <svg {...base} {...p}>
      <path d="M12 3v12" />
      <path d="m7 11 5 5 5-5" />
      <path d="M4 20h16" />
    </svg>
  ),
  Tablet: (p) => (
    <svg {...base} {...p}>
      <rect x="5" y="2" width="14" height="20" rx="2" />
      <path d="M9 6h6M9 10h6M9 14h3" />
      <circle cx="12" cy="18.5" r=".6" fill="currentColor" />
    </svg>
  ),
  Sensor: (p) => (
    <svg {...base} {...p}>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 3v3M12 18v3M3 12h3M18 12h3" />
      <path d="M6.5 6.5a7.8 7.8 0 0 0 0 11M17.5 6.5a7.8 7.8 0 0 1 0 11" />
    </svg>
  ),
  Brain: (p) => (
    <svg {...base} {...p}>
      <path d="M12 5.5a3 3 0 0 0-5.7-1.3A2.8 2.8 0 0 0 4 7a2.9 2.9 0 0 0 .8 2A2.9 2.9 0 0 0 4 11.5c0 1.2.8 2.3 1.9 2.7A2.9 2.9 0 0 0 9 19a3 3 0 0 0 3-2.4z" />
      <path d="M12 5.5a3 3 0 0 1 5.7-1.3A2.8 2.8 0 0 1 20 7a2.9 2.9 0 0 1-.8 2A2.9 2.9 0 0 1 20 11.5c0 1.2-.8 2.3-1.9 2.7A2.9 2.9 0 0 1 15 19a3 3 0 0 1-3-2.4z" />
      <path d="M12 5.5v11" />
    </svg>
  ),
  Bolt: (p) => (
    <svg {...base} {...p}>
      <path d="M13 2 4.5 13H11l-1 9 8.5-11H12z" />
    </svg>
  ),
  Rocket: (p) => (
    <svg {...base} {...p}>
      <path d="M12 3c3 2 5 5.6 5 9.5L12 17l-5-4.5C7 8.6 9 5 12 3z" />
      <circle cx="12" cy="10" r="1.6" />
      <path d="M9 16.5 6.5 19M15 16.5 17.5 19M12 17v4" />
    </svg>
  ),
  Plug: (p) => (
    <svg {...base} {...p}>
      <path d="M9 3v5M15 3v5" />
      <path d="M6 8h12v3a6 6 0 0 1-6 6 6 6 0 0 1-6-6z" />
      <path d="M12 17v4" />
    </svg>
  ),
  Pulse: (p) => (
    <svg {...base} {...p}>
      <path d="M3 12h4l2-6 4 12 2-6h6" />
    </svg>
  ),
  Cart: (p) => (
    <svg {...base} {...p}>
      <path d="M3 4h2l2.4 11.2a1 1 0 0 0 1 .8h9.2a1 1 0 0 0 1-.8L20 8H6.2" />
      <circle cx="9.5" cy="19.5" r="1.2" />
      <circle cx="17" cy="19.5" r="1.2" />
    </svg>
  ),
  Home: (p) => (
    <svg {...base} {...p}>
      <path d="M3.5 11 12 4l8.5 7" />
      <path d="M5.5 9.5V20h13V9.5" />
      <path d="M10 20v-5.5h4V20" />
    </svg>
  ),
  Chat: (p) => (
    <svg {...base} {...p}>
      <path d="M4 5h16v11H9.5L5 19.5V16H4z" />
      <path d="M8 9.5h8M8 12.5h5" />
    </svg>
  ),
  Search: (p) => (
    <svg {...base} {...p}>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M20 20l-4.2-4.2" />
    </svg>
  ),
};

export default Icon;
